import { defineMessages } from 'react-intl';

export default defineMessages({
    point1: {
        id: '_.bwa_susa.point1',
        defaultMessage: ' '
    },
    point2: {
        id: '_.bwa_susa.point2',
        defaultMessage: ' '
    }
});
